/**
 * Props for the DataTableColumnOrderSettings component.
 * @public
 */
export interface DataTableColumnOrderSettingsProps {
  /**
   * Column order reset state that will be used to reset and also to enable/disable 'Reset to default'
   * in column settings modal.
   */
  resetColumnOrder?: string[];
}

/**
 * The slot component serves the sole purpose of detecting the user's intention
 * to display column order within the column settings modal, situated in the DataTable toolbar.
 * @public
 */
export const DataTableColumnOrderSettings = ({
  resetColumnOrder,
}: DataTableColumnOrderSettingsProps) => null;

DataTableColumnOrderSettings.displayName = 'DataTable.ColumnOrderSettings';
